module.exports = __webpack_public_path__ + "static/media/img-19.1c57a68f.jpg";